<template>
  <div
    :class="[
      $style.container,
      {
        MicrositePlaceholder__scrollNavigation: config.isScrollNavigation,
      },
    ]"
  >
    <div v-if="!config.isStartElement" :id="config.anchorName" :class="$style.anchor" />
    <h2
      v-if="!config.isStartElement && !config.isScrollNavigation && config.title"
      :class="$style.title"
    >
      {{ config.title }}
    </h2>
    <h1
      v-if="config.isStartElement && !config.isScrollNavigation && config.title"
      :class="$style.startElementTitle"
    >
      {{ config.title }}
    </h1>
    <div :class="$style.contentArea">
      <div v-if="config.isScrollNavigation" class="ScrollNavigation__container">
        <ScrollNavigation
          :big-buttons="config.bigButtons"
          :config="config.content.scrollNavigation"
          :scroll-container-id="config.scrollContainerId"
          :sticky-nav-id="config.stickyNavId"
          :title="config.title"
        />
        <div :id="config.scrollContainerId">
          <section
            :id="config.content.scrollNavigation.sNPlaceholder1.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <h4 class="ScrollNavigation__itemTitle">Sensors</h4>
            <TextImageElement
              image="https://picsum.photos/472/266?random=1"
              :image-right="false"
              link-title="Portabler Prozesskalibrator"
            >
              <template #default>
                <h1>Radio Units for measuring instruments</h1>

                <p>
                  With our modern NETRIS radio units and IIoT gateways, your existing measuring
                  instruments become network-capable and can communicate via the following standard
                  interfaces:
                </p>

                <ul>
                  <li>Analogue: 4 … 20 mA</li>
                  <li>Analogue: 0.5 … 4.5 V ratiometric</li>
                  <li>Analogue & digital: RTD</li>
                  <li>Digital: ModBus®</li>
                </ul>

                <p>
                  These are compatible with <a href="#">established</a> wireless technologies such
                  as LoRaWAN®, mioty, NB-IOT or LTM-M.
                </p>
              </template>
            </TextImageElement>
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder2.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <h4 class="ScrollNavigation__itemTitle">Connectivity</h4>
            <TextImageElement
              image="https://picsum.photos/472/266?random=2"
              :image-right="false"
              link-title="Portabler Prozesskalibrator"
            >
              <template #default>
                Der Prozesskalibrator CPH7000 von WIKA hat ATEX-Zulassung
              </template>
            </TextImageElement>
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder3.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <h4 class="ScrollNavigation__itemTitle">Cloud</h4>
            <TextImageElement
              image="https://picsum.photos/472/266?random=3"
              :image-right="false"
              link-title="Portabler Prozesskalibrator"
            >
              <template #default>
                Der Prozesskalibrator CPH7000 von WIKA hat ATEX-Zulassung
              </template>
            </TextImageElement>
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder4.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <h4 class="ScrollNavigation__itemTitle">Application</h4>
            <TextImageElement
              image="https://picsum.photos/472/266?random=4"
              :image-right="false"
              link-title="Portabler Prozesskalibrator"
            >
              <template #default>
                Der Prozesskalibrator CPH7000 von WIKA hat ATEX-Zulassung
              </template>
            </TextImageElement>
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder5.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <h4 class="ScrollNavigation__itemTitle">{{ 'z-index bugfix WIKA-4532' }}</h4>
            <TextTeaser
              head="Hochwertige Digitalmanometer von WIKA"
              :is-static="false"
              :links="[
                'Schutzrohrberechnung',
                'Bauweise von Schutzrohren in Sonderlänge',
                'Fragebogen für Schutzrohre',
              ]"
              text="WIKA Präzisions-Digitalmanometer wie beispielsweise der Typ CPG1500 eignen sich sowohl
                für die stationäre als auch die mobile Messung und Anzeige von Drücken. Ein weiterer
                Vorteil ist, dass Digitalmanometer zudem als Druckreferenz verwendet werden können.
                Dies ermöglicht das einfache Überprüfen, Einstellen und Kalibrieren von anderen
                Druckmesseinrichtungen direkt vor Ort. Durch leistungsfähige Messzellen wird eine hohe
                Genauigkeit von 0,05 % FS erreicht. Neben zahlreichen Konfigurationsmöglichkeiten stehen
                Ihnen in unserem Online-Shop ergänzend komplette Service-Kits, bestehend aus
                Digitalmanometer, Handprüfpumpe und verschiedensten Anschlussadaptern mit geringen
                Lieferzeiten zur Verfügung. WIKA Präzisions-Digitalmanometer wie beispielsweise der Typ
                CPG1500 eignen sich sowohl für die stationäre als auch die mobile Messung und Anzeige von
                Drücken. Ein weiterer Vorteil ist, dass Digitalmanometer zudem als Druckreferenz
                verwendet werden können."
            />
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder6.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <HeroSlider :slides="testSlides" />
          </section>
          <section
            :id="config.content.scrollNavigation.sNPlaceholder7.anchorName"
            class="ScrollNavigation__contentArea"
          >
            <TextMediaElement
              :image="textMedia.image"
              :is-mp4="textMedia.isMp4"
              :media-right="textMedia.mediaRight"
              :text="textMedia.text"
              :title="textMedia.title"
              :video="textMedia.video"
              :youtube="textMedia.youtube"
            />
          </section>
        </div>
      </div>
      <Wysiwyg v-if="config.content.WYSIWYG" />
      <TextImageElement
        v-if="config.content.textImageElement"
        :image="config.content.textImageElement.image"
        :image-right="config.content.textImageElement.imageRight"
        :link-title="config.content.textImageElement.linkTitle"
      >
        <template #default>
          {{ config.content.textImageElement.text }}
        </template>
      </TextImageElement>
      <div v-if="config.content.row" class="columns is-multiline">
        <div class="column is-half-tablet">
          <ContentTeaserS
            v-if="config.content.row.teasers"
            :category="config.content.row.teasers.teaser1.category"
            :image="config.content.row.teasers.teaser1.image"
            :is-video="false"
            :link-title="config.content.row.teasers.teaser1.linkTitle"
            primary-link="#"
            :primary-link-new-window="true"
            secondary-link="#"
            :secondary-link-new-window="false"
            :wt-params="config.content.row.teasers.teaser1.wtParams"
          />
        </div>
        <div class="column is-half-tablet">
          <ContentTeaserS
            v-if="config.content.row.teasers"
            :category="config.content.row.teasers.teaser2.category"
            :image="config.content.row.teasers.teaser2.image"
            :is-video="false"
            :link-title="config.content.row.teasers.teaser2.linkTitle"
            primary-link="#"
            :primary-link-new-window="true"
            secondary-link="#"
            :secondary-link-new-window="false"
            :wt-params="config.content.row.teasers.teaser2.wtParams"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card1"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card2"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card3"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card4"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card5"
          />
        </div>
        <div class="column is-one-third-tablet">
          <FlipCard
            v-if="config.content.row.flipcards"
            :config="config.content.row.flipcards.card6"
          />
        </div>
      </div>
      <div class="columns StartPage__contentGrid StartPage__WebStart1XP">
        <div class="column is-one-quarter-tablet">
          <Button
            v-if="config.content.row?.buttons"
            class="Button__center"
            :colour="config.content.row?.buttons.button1.colour"
            :no-border="config.content.row.buttons.button1.noBorder"
            :rounded-corners="config.content.row.buttons.button1.roundedCorners"
            :text="config.content.row.buttons.button1.text"
            type="button"
          />
        </div>
        <div class="column is-one-quarter-tablet">
          <Button
            v-if="config.content.row?.buttons"
            class="Button__center"
            :colour="config.content.row.buttons.button2.colour"
            :no-border="config.content.row.buttons.button2.noBorder"
            :rounded-corners="config.content.row.buttons.button2.roundedCorners"
            :text="config.content.row.buttons.button2.text"
            type="button"
          />
        </div>
        <div class="column is-one-quarter-tablet">
          <Button
            v-if="config.content.row?.buttons"
            class="Button__center"
            :colour="config.content.row.buttons.button3.colour"
            :no-border="config.content.row.buttons.button3.noBorder"
            :rounded-corners="config.content.row.buttons.button3.roundedCorners"
            :text="config.content.row.buttons.button3.text"
            type="button"
          />
        </div>
        <div class="column is-one-quarter-tablet">
          <Button
            v-if="config.content.row?.buttons"
            class="Button__center"
            :colour="config.content.row.buttons.button4.colour"
            :no-border="config.content.row.buttons.button4.noBorder"
            :rounded-corners="config.content.row.buttons.button4.roundedCorners"
            :text="config.content.row.buttons.button4.text"
            type="button"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <HeroSlider v-if="config.content.row?.slides" :slides="config.content.row.slides" />
        </div>
        <div class="column is-full">
          <Wysiwyg v-if="config.content.row?.WYSIWYG" />
        </div>
      </div>
      <HeroSlider v-if="config.content.slides" :slides="config.content.slides" />
      <ContactForm v-if="config.content.form" :config="config.content.form" />
    </div>
  </div>
</template>

<script setup>
import Button from '../Button/Button.vue';
import ContactForm from '../ContactForm/ContactForm.vue';
import ContentTeaserS from '../ContentTeaserS/ContentTeaserS.vue';
import FlipCard from '../FlipCard/FlipCard.vue';
import HeroSlider from '../HeroSlider/HeroSlider.vue';
import ScrollNavigation from '../ScrollNavigation/ScrollNavigation.vue';
import TextImageElement from '../TextImageElement/TextImageElement.vue';
import Wysiwyg from '../Wysiwyg/Wysiwyg.vue';
import TextTeaser from '../TextTeaser/TextTeaser.vue';
import TextMediaElement from '../TextMediaElement/TextMediaElement.vue';

defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const testSlides = [
  {
    image: 'https://picsum.photos/1024/334',
    captionLeft: true,
    text: 'Durch die Teilnahme an der spezifischen Ausbildungsreihe für Projektmanager werden Sie nicht nur Ihre eigenen Fähigkeiten und Kenntnisse erweitern, sondern auch zu einem einheitlichen Standard und einer gemeinsamen Sprache im Projektmanagement beitragen. Sie werden Teil eines starken Netzwerks von Projektmanagern und haben die Gelegenheit, Erfahrungen auszutauschen, „Best Practices" zu teilen und voneinander zu lernen.',
    title: 'WIKA-Projektleiterausbildung',
  },
  {
    image: 'https://picsum.photos/1024/334',
    imageWidth: 1024,
    imageHeight: 344,
    text: '',
    title:
      'Only title, no text: Willkommen bei WIKA SF<sup>6</sup> WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung. WIKA ist weltweit SF<sup>6</sup> führend in der Druck-, Temperatur-, Füllstands-, Kraft- und Durchflussmesstechnik sowie der Kalibrierung.',
  },
];

const textMedia = {
  mediaRight: false,
  isMp4: true,
  title: 'Lorem ipsum',
  text: 'At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
  slides: [],
  video: 'https://media.w3.org/2010/05/sintel/trailer.mp4',
  image: 'https://i.ytimg.com/vi/WQ_lbJfiffs/mqdefault.jpg',
  youtube: '',
};
</script>

<style module lang="scss">
@forward './MicrositePlaceholder.scss';
</style>
